import { useEffect, useState } from 'react';

/**
 * Returns the current Date, updated on the given interval.
 * Intended for decorative live clocks (landing page demo, CTA tick, etc.).
 */
export function useNow(intervalMs: number = 1000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
